<admin-table-standard [items]="factor.flags" [custom]="['inner-table']" *ngIf="factor.result! > 0; else negativeResult">
  <ng-template #header>
    <th scope="col" class="col-md-1 text-lowercase">{{'pages.lookup.single.result.alert.risk' | translate }}</th>
    <th scope="col" class="col-md-4 text-lowercase">{{'pages.lookup.single.result.alert.info' | translate }}</th>
    <th scope="col" class="col-md-1 text-lowercase">{{'pages.lookup.single.result.alert.hits' | translate }}</th>
    <th scope="col" class="col-md-1 text-lowercase">{{'pages.lookup.single.result.alert.result' | translate }}</th>
  </ng-template>
  <ng-template #first let-item>
    <td><div class="text-uppercase fw-bolder"><span [ngClass]="'text-' + riskClass(item.scoring)">{{('pages.lookup.single.result.alert_risk.' + item.scoring.risk | translate)}}</span></div></td>
    <td class="text-dark text-truncate-custom">{{ item.scoring.info }}</td>
    <td class="fw-bolder">{{ item.scoring.hits.length }}</td>
    <td><span [ngClass]="'text-' + riskClass(item.scoring)" class="fw-bolder">{{item.scoring.result?.toFixed(1)}}</span></td>
  </ng-template>
</admin-table-standard>

<ng-template #negativeResult>
  <admin-table-standard [items]="[factor]" [custom]="['inner-table']">
    <ng-template #header>
      <th scope="col" class="col-md-1 text-lowercase">{{'pages.lookup.single.result.alert.risk' | translate }}</th>
      <th scope="col" class="col-md-4 text-lowercase">{{'pages.lookup.single.result.alert.info' | translate }}</th>
      <th scope="col" class="col-md-1 text-lowercase">{{'pages.lookup.single.result.alert.hits' | translate }}</th>
      <th scope="col" class="col-md-1 text-lowercase">{{'pages.lookup.single.result.alert.result' | translate }}</th>
    </ng-template>
    <ng-template #first let-item>
      <td><div class="text-uppercase fw-bolder"><span [ngClass]="'text-secondary'">{{('pages.lookup.single.result.alert_risk.none' | translate)}}</span></div></td>
      <td class="text-dark text-truncate-custom">{{ factor.info }}</td>
      <td><span class="fw-bolder">{{ 0 }}</span></td>
      <td><span [ngClass]="'text-secondary fw-bolder'">0.0</span></td>
    </ng-template>
  </admin-table-standard>
</ng-template>
